import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordDialogComponent } from '../forgot-password-dialog/forgot-password-dialog.component';
import { UpdatePhoneNumberDialogComponent } from '../../modal/update-phone-number-dialog/update-phone-number-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  otpForm: FormGroup;
  randomNumber: string;
  numberMatch: boolean;
  slides = [
    {img: "/eicher/assets/img/CSAT_2025-04.jpeg"},
    {img: "/eicher/assets/img/CSAT_2025-05.jpeg"},
    {img: "/eicher/assets/img/CSAT_2025-06.jpeg"},
    {img: "/eicher/assets/img/CSAT_2025-01.jpeg"},
    {img: "/eicher/assets/img/CSAT_2025-02.jpeg"},
    {img: "/eicher/assets/img/CSAT_2025-03.jpeg"},
  ];
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000
  };
  
  constructor(private fb: FormBuilder, private commonService: CommonService, private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,) { }
  submitted: boolean;
  submittedOtp: boolean;
  spinner: boolean;
  showLogin: boolean;
  user: any;
  count: number;
  flag: string;
  userName: string;

  ngOnInit() {
    if (localStorage.getItem('userId') != null
    && localStorage.getItem('userId') != undefined
    && localStorage.getItem('userRoles') != null
    && localStorage.getItem('userRoles') != undefined) {
      if (localStorage.getItem('userRoles') == 'CRE') {
        this.router.navigate(['calling']);
      } else if (localStorage.getItem('userRoles') == 'Call Center Agent') {
        this.router.navigate(['prs-calling']);
      } else if (localStorage.getItem('userRoles') == "Team Leader" || localStorage.getItem('userRoles') == "Manager") {
        this.router.navigate(['prs-reporting']);
      } else {
        this.router.navigate(['dashboard']);
      }
    } else {
      this.showLogin = true;
      //this.getSigninUpdate(this.userName, 'N', '0');
      this.buildLoginForm();
      this.buildOtpForm();
    }

    this.randomNumber = Math.floor(1000 + Math.random() * 9000).toString();
  }

  /**
  * Name: buildLoginForm
  * purpose: To create customer data form
  */
  buildLoginForm() {
    this.loginForm = this.fb.group({
      UserId: ['', Validators.required],
      password: ['', Validators.required],
      captchaNumber: ['']
    });
  }
  /**
  * Name: buildOtpForm
  * purpose: To create otp data form
  */
  buildOtpForm() {
    this.otpForm = this.fb.group({
      otp: ['', Validators.required]
    });
  }

  /**
  * Name: hasError
  * purpose: To check if customer form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasError(control: any): boolean {
    return (
      control &&
      (this.submitted || control.touched || control.dirty) &&
      !control.valid
    );
  }

  getSigninCheck(): void {
    let user = this.loginForm.value.UserId
    this.commonService.getSigninCheck(user).subscribe(res => {
      if (res['responseCode'] == 0) {
        let response = res['responseData'][0];
        this.flag = response.flag;
        this.count = response.counts;
        //if(this.flag == 'N') {
          // if(this.count < 5) {
            this.login();
          // } else {
          //   this.toastr.info("You are exceed the maximum limit of login. Please click on FORGOT PASSWORD? link to get your correct password.");
          // }
        // } else {
        //   this.toastr.info("You are already login on different system.");
        // }
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, error => {
      this.spinner = false;
      this.toastr.error(error, "Error");
    });
  }

  getSigninUpdate(user: string, flag: string, count: string): void {
    this.commonService.getSigninUpdate(user, flag, count).subscribe(res => {
      if (res['responseCode'] == 0) {
        //console.log(res['responseData'].message);
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, error => {
      this.spinner = false;
      this.toastr.error(error, "Error");
    });
  }

  /**
  * Name: login
  * purpose: To Sign in user
  */
  login(): void {
    let f = this.loginForm;
    this.submitted = true;
    if (f.valid) {
      if(this.randomNumber==f.value.captchaNumber) {
        this.numberMatch=false
        let username = f.value.UserId;
        let password = f.value.password;
        this.spinner = true;
        //this.getSigninCheck(username);
        //if(this.flag != 'Y') {
        this.commonService.signin(username, password).subscribe(res => {
          if (res['responseCode'] == 0) {
            this.user = res['responseData'];
            localStorage.setItem('userId', this.user.userId);
            localStorage.setItem('roleId', this.user.roleId);
            localStorage.setItem('countryCode', this.user.countryCode);
            if(this.user.countryCode == "IND91") {
              if (this.user.loginCount == null || this.user.loginCount == 0) {
                const dialogRef = this.dialog.open(UpdatePhoneNumberDialogComponent, {
                  width: '450px',
                  height: '400px',
                  data: {},
                  disableClose: true
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result) {
                    this.sendOTP();                
                    this.showLogin = false;
                    this.toastr.info(result['message']);
                  }
                });
              } else {
                this.sendOTP();
                this.showLogin = false;
              }              
            } else {
              this.validateOTP();
            }
          } else {
            this.spinner = false;
            this.submitted = false;
            this.toastr.error(res['message'], "Error");
            let count = this.count + 1;
            this.getSigninUpdate(username, this.flag, count.toString());
            if(this.count > 5) {
              this.toastr.info("You are exceed the maximum limit of login. Please click on FORGOT PASSWORD? link to get your correct password.");
            }
          }
        }, error => {
          this.spinner = false;
          this.submitted = false;
          this.toastr.error(error, "Error");
        });
        // } else {
        //   this.toastr.info("You are already login in different system.");
        // }
      } else {
        this.randomNumber = Math.floor(1000 + Math.random() * 9000).toString();
        this.numberMatch=true
        this.submitted = false;
      }
    } else {
      this.submitted = false;
    }
  }

  sendOTP() {
    this.spinner = true;
    this.commonService.sendOTP(this.user.userId).subscribe(res => {
      if (res['responseCode'] == 0) {
        this.toastr.info(res['message']);
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, error => {
      this.spinner = false;
      this.toastr.error(error, "Error");
    });
  }

  validateOTP() {
    let otp = this.otpForm.value.otp
    this.spinner = true;
    this.submittedOtp = true;
    this.commonService.verifyOTP(this.user.userId, this.user.roleId, otp, this.user.countryCode).subscribe(res => {
      if (res['responseCode'] == 0) {
        this.user = res['responseData'];
        localStorage.setItem('userId', this.user.userId);
        localStorage.setItem('token', this.user.accessToken);
        localStorage.setItem('tokenType', this.user.tokenType);
        localStorage.setItem('userRoles', this.user.roles);
        localStorage.setItem('uamAccess', this.user.uamAccess);
        localStorage.setItem("LoginTime", JSON.stringify(new Date().getTime()));
        localStorage.setItem('expirationTime', this.user.expirationTime);
        localStorage.setItem('countryCode', this.user.countryCode);
        localStorage.setItem('roleId', this.user.roleId);
        this.getUserDetails(this.user.userId, this.user.roleId);
        this.userName = this.user.userId;
        this.spinner = false;
      } else {
        this.spinner = false;
        this.submittedOtp = false;
        this.toastr.error(res['message'], "Error");
      }
    }, error => {
      this.spinner = false;
      this.submittedOtp = false;
      this.toastr.error(error, "Error");
    });
  }

  /**
  * Name: getUserDetails
  * @param {string} userId - userId
  * purpose: To get login user details
  */
  getUserDetails(userId: string, roleId: string) {
    this.spinner = true;
    this.commonService.getUserDetails(userId, roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'].length) {
          let user = res['responseData'][0];
          localStorage.setItem('userInfo', JSON.stringify(res['responseData']));
          localStorage.setItem('userName', user.username);
          localStorage.setItem('roleId', user.roleId);
          localStorage.setItem('userContactNo',user.contactNo);
          localStorage.setItem('isLoggedIn', 'true');
          this.navigateBasedOnRole();
          this.toastr.info(user.username, "Welcome");
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, error => {
        this.spinner = false;
        this.toastr.error(error, "Error");
      });
  }

  private navigateBasedOnRole() {
    if (this.user.roles[0] == 'CRE') {
      this.router.navigate(['calling']);
    } else if (this.user.roles[0] == 'Call Center Agent') {
      this.router.navigate(['prs-calling']);
    } else if (this.user.roles[0] == "Team Leader" || this.user.roles[0] == "Manager") {
      this.router.navigate(['prs-reporting']);
    } else if (this.user.roles[0] == "Workshop Manager") {
      this.router.navigate(['soft-calling']);
    } else {
      this.router.navigate(['dashboard']);
    }
  }

  /**
  * Name: enterSignin
  * purpose: To Sign in user with enter key
  */
  enterSignin(event: any) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

   /**
  * Name: forgotPassword
  * purpose: To Sign in user with enter key
  */
  forgotPassword() {
    const dialogRef = this.dialog.open(ForgotPasswordDialogComponent, {
      width: '550px',
      height: '450px',
      data: {}
    });
  }

  refreshCaptcha(){
    this.randomNumber = Math.floor(1000 + Math.random() * 9000).toString();
  }
}
